import { DashboardOutlined } from '@ant-design/icons';

import DashboardPage from '../pages/DashboardPage';

import { SiteMap } from './index';

export const dashboardRoutes: SiteMap = {
  dashboard: {
    title: '대시보드',
    page: DashboardPage,
    key: '/dashboard',
    icon: <DashboardOutlined />,
  },
};
